<ion-content fullscreen class="full-bg">
  <app-fullscreen>
    <div class="container" header>
      <app-step-header
        [hideBack]="true"
        [hideProgress]="true">
      </app-step-header>
    </div>
    <div class="container feedback" body>
      <p *ngFor="let message of messages" class="feedback-message" [innerHTML]="message | translate"></p>
      <ion-icon *ngIf="!!figure"
        class="feedback-icon primary-icon"
        [name]="figure">
      </ion-icon>
    </div>
    <div footer>
      <app-footer
        position="block"
        [secondaryButton]="{ hidden: true }"
        [primaryButton]="{ icon: 'checkmark', text: okText || '' | translate }"
        (primaryClick)="close()">
      </app-footer>
    </div>
  </app-fullscreen>
</ion-content>
